import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Fade } from '@material-ui/core'
import { Alert as AlertBase } from '@material-ui/lab'
import { useHistory } from 'react-router-dom'

const Notification = props => {
  const items = useSelector(state => state.notification)
  const history = useHistory()

  return (
    <Container onClick={event => history.push('/my-cart')}>
      {items.map((item, index) => (
        <Fade in={item.open} key={index} timeout={700}>
          <Alert icon={false} style={{ position: 'relative' }} severity={item.type || 'success'}>
            {item.message}
          </Alert>
        </Fade>
      ))}
    </Container>
  )
}

const Container = styled.section`
  position: fixed;
  z-index: 11;
  bottom: 40px;
  left: 40px;
  width: 100%;
  max-width: 300px;
  transition: all 1s;
  cursor: pointer;
  & .MuiAlert-standardSuccess {
    background-color: var(--first)!important;
    color: #fff!important;
      & svg {
      color: #fff!important;
      font-weight: bold;
    }
  }
  & .MuiAlert-action {
    display: flex;
    align-items: center;
    margin-left: auto;
    margin-right: -8px;
    padding-left: 16px;
    position: absolute;
    top: 10px;
    right: 11px;
  }
`

const Alert = styled(AlertBase)`
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 5px;
  min-height: 70px;
  align-items: center;
  font-size: 1.1em;
  box-shadow: 2px 2px 5px #000;
`
export default Notification
